export default __webpack_public_path__ + "static/media/ic_Hamburger.04cfbe69.svg";